import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  IconCheck,
  IconX,
  IconListDetails,
  IconEye,
  IconPhoto,
  IconSearch,
  IconChartPie,
  IconUser,
  IconCircleCheck,
  IconClock,
  IconBuildingStore,
  IconAlertTriangle,
  IconInbox,
  IconAdjustmentsHorizontal,
  IconChevronDown,
  IconChevronUp,
  IconCalendarTime,
  IconReload,
} from '@tabler/icons-react';
import Layouts from '../../layouts/Layouts';
import { getAuthorizationHeader, http, imageBaseUrl } from '../../config/http';
import { toast } from 'react-toastify';
import moment from 'moment';
import DetailItem from '../Modal/DetailItem';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css'; 
import 'react-date-range/dist/theme/default.css';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';

export default function HistoriPenghapusan({ isVerifikasi }) {
  const [activeTab, setActiveTab] = useState('pengajuan'); // 'pengajuan' or 'barang'
  const [data, setData] = useState([]);
  const [barangData, setBarangData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openDetail, setOpenDetail] = useState(false);
  const [detailItem, setDetailItem] = useState([]);
  const navigate = useNavigate();
  const userRole = (localStorage.getItem('role') || '').toLowerCase().trim();
  const canVerify = userRole === 'admin' || userRole === 'owner' || userRole === 'verifikator';
  const isOperatorToko = userRole === 'operator' || userRole === 'operator_toko';

  useEffect(() => {
    if (!isVerifikasi && !isOperatorToko) {
      toast.error('Akses ditolak: Menu Pengajuan Hapus hanya dapat diakses oleh Operator Toko', {
        toastId: 'access-denied-pengajuan-hapus',
      });
      navigate('/list-items-admin');
    }
  }, [isVerifikasi, isOperatorToko, navigate]);

  // 5-Tab Detail Modal State
  const [isOpenDetailModal, setIsOpenDetailModal] = useState(false);
  const [selectedPengajuan, setSelectedPengajuan] = useState(null);
  const [modalTab, setModalTab] = useState('ringkasan'); // 'ringkasan' | 'list' | 'operator' | 'verifikator' | 'galeri'
  const [searchModalItem, setSearchModalItem] = useState('');

  // Pagination Table State
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const [barangCurrentPage, setBarangCurrentPage] = useState(1);
  const [totalBarangPages, setTotalBarangPages] = useState(1);
  const [totalBarangItems, setTotalBarangItems] = useState(0);
  const [barangFrom, setBarangFrom] = useState(0);
  const [barangTo, setBarangTo] = useState(0);
  const barangItemsPerPage = 10;

  // Filter States
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [statusFilter, setStatusFilter] = useState('');
  const [cabangFilter, setCabangFilter] = useState('');
  const [operatorFilter, setOperatorFilter] = useState('');
  const [searchQuery, setSearchQuery] = useState('');

  const [confirmModal, setConfirmModal] = useState({
    isOpen: false,
    id: null,
    action: null,
    pengajuan: null,
  });
  const [catatanVerifikasi, setCatatanVerifikasi] = useState('');

  const confirmAction = (pengajuanOrId, action) => {
    let target = null;
    if (typeof pengajuanOrId === 'object' && pengajuanOrId !== null) {
      target = pengajuanOrId;
    } else {
      target = data.find((p) => p.id === pengajuanOrId) || selectedPengajuan;
    }
    setCatatanVerifikasi('');
    setConfirmModal({
      isOpen: true,
      id: target?.id || pengajuanOrId,
      action,
      pengajuan: target,
    });
  };

  const processConfirmAction = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (!confirmModal.id || !confirmModal.action) return;
    await handlePersetujuan(confirmModal.id, confirmModal.action, catatanVerifikasi);
    setConfirmModal({ isOpen: false, id: null, action: null, pengajuan: null });
    setCatatanVerifikasi('');
    setIsOpenDetailModal(false);
  };

  // Resolve Image URL Helper
  const resolveItemImageUrl = (item) => {
    if (!item) return '';
    let gData = item.gambar1 || item.gambar || item.foto;
    if (typeof gData === 'string' && (gData.startsWith('[') || gData.startsWith('{'))) {
      try {
        gData = JSON.parse(gData);
      } catch (e) {}
    }
    if (Array.isArray(gData) && gData.length > 0) {
      const path = gData[0]?.asli || gData[0]?.thumbnail || (typeof gData[0] === 'string' ? gData[0] : '');
      return path ? (path.startsWith('http') ? path : `${imageBaseUrl}${path}`) : '';
    }
    if (typeof gData === 'string' && gData.length > 0) {
      return gData.startsWith('http') ? gData : `${imageBaseUrl}${gData}`;
    }
    return '';
  };

  // Normalized Item List inside Modal
  const modalItemList = useMemo(() => {
    if (!selectedPengajuan || !selectedPengajuan.items) return [];
    return selectedPengajuan.items
      .map((child) => {
        const itemObj = child.item || child;
        if (!itemObj) return null;
        return {
          ...itemObj,
          status_item: child.status || selectedPengajuan.status_pengajuan,
          raw_child: child,
        };
      })
      .filter(Boolean);
  }, [selectedPengajuan]);

  // Filtered Items inside Modal (Tab List & Tab Galeri)
  const filteredModalItems = useMemo(() => {
    if (!modalItemList.length) return [];
    if (!searchModalItem.trim()) return modalItemList;
    const q = searchModalItem.toLowerCase();
    return modalItemList.filter((it) => {
      const kode = it.kode_item ? it.kode_item.toLowerCase() : '';
      const jenis = it.jenis_kategori?.nama_jenis ? it.jenis_kategori.nama_jenis.toLowerCase() : '';
      const kat = it.jenis_kategori?.kategori?.nama_kategori ? it.jenis_kategori.kategori.nama_kategori.toLowerCase() : '';
      const baki = it.nomor_rak ? it.nomor_rak.toString().toLowerCase() : '';
      return kode.includes(q) || jenis.includes(q) || kat.includes(q) || baki.includes(q);
    });
  }, [modalItemList, searchModalItem]);

  const detailSummary = useMemo(() => {
    if (!selectedPengajuan || !selectedPengajuan.items) return {};
    return selectedPengajuan.items.reduce((acc, child) => {
      const item = child.item || child;
      if (!item) return acc;
      const catName = item.jenis_kategori?.kategori?.nama_kategori || 'Tanpa Kategori';
      const karat = item.karat || '-';
      const berat = parseFloat(item.berat || 0);

      if (!acc[catName]) acc[catName] = { name: catName, pcs: 0, berat: 0, byKarat: {} };
      acc[catName].pcs += 1;
      acc[catName].berat += berat;

      if (!acc[catName].byKarat[karat]) acc[catName].byKarat[karat] = { pcs: 0, berat: 0 };
      acc[catName].byKarat[karat].pcs += 1;
      acc[catName].byKarat[karat].berat += berat;

      return acc;
    }, {});
  }, [selectedPengajuan]);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isDateOpen, setIsDateOpen] = useState(false);
  const dateDropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dateDropdownRef.current && !dateDropdownRef.current.contains(event.target)) {
        setIsDateOpen(false);
      }
    }
    if (isDateOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDateOpen]);

  const selectionRange = {
    startDate: startDate || new Date(),
    endDate: endDate || new Date(),
    key: 'selection',
  };

  const handleSelectDate = (date) => {
    setStartDate(date.selection.startDate);
    setEndDate(date.selection.endDate);
  };

  const fetchDataPengajuan = useCallback(async () => {
    setLoading(true);
    try {
      const res = await http.get('/item-deletions', {
        headers: { Authorization: getAuthorizationHeader() },
      });
      let result = res.data.data || [];
      if (startDate && endDate) {
         result = result.filter(item => {
           const date = moment(item.created_at);
           return date.isBetween(moment(startDate).startOf('day'), moment(endDate).endOf('day'), null, '[]');
         });
      }
      setData(result);
    } catch (err) {
      console.log(err);
      toast.error('Gagal mengambil data pengajuan');
    }
    setLoading(false);
  }, [startDate, endDate]);

  useEffect(() => {
    fetchDataPengajuan();
  }, [fetchDataPengajuan]);

  useEffect(() => {
    if (activeTab === 'pengajuan') {
      fetchDataPengajuan();
    }
  }, [activeTab, fetchDataPengajuan]);

  const fetchDataBarang = useCallback(async (targetPage = barangCurrentPage) => {
    setLoading(true);
    try {
      let url = `/item-deletions/histori-barang?limit=${barangItemsPerPage}&page=${targetPage}`;
      if (statusFilter) {
        url += `&status=${encodeURIComponent(statusFilter)}`;
      }
      if (cabangFilter) {
        url += `&cabang=${encodeURIComponent(cabangFilter)}`;
      }
      if (operatorFilter) {
        url += `&operator=${encodeURIComponent(operatorFilter)}`;
      }
      if (searchQuery.trim()) {
        url += `&search=${encodeURIComponent(searchQuery.trim())}`;
      }
      if (startDate && endDate) {
        url += `&start_date=${moment(startDate).format('YYYY-MM-DD')}&end_date=${moment(endDate).format('YYYY-MM-DD')}`;
      }
      const res = await http.get(url, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      const paginator = res.data.data;
      setBarangData(paginator?.data || []);
      setTotalBarangPages(paginator?.last_page || 1);
      setTotalBarangItems(paginator?.total || 0);
      setBarangFrom(paginator?.from || 0);
      setBarangTo(paginator?.to || 0);
    } catch (err) {
      console.log(err);
      toast.error('Gagal mengambil data histori barang');
    }
    setLoading(false);
  }, [barangCurrentPage, barangItemsPerPage, statusFilter, cabangFilter, operatorFilter, searchQuery, startDate, endDate]);

  useEffect(() => {
    if (activeTab === 'barang') {
      const timer = setTimeout(() => {
        fetchDataBarang(barangCurrentPage);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [activeTab, barangCurrentPage, statusFilter, cabangFilter, operatorFilter, searchQuery, startDate, endDate, fetchDataBarang]);

  const handlePersetujuan = async (id, action, catatan = '') => {
    setLoading(true);
    try {
      const payload = { action };
      if (catatan) payload.catatan = catatan;
      await http.post(
        `/item-deletions/${id}/persetujuan`,
        payload,
        { headers: { Authorization: getAuthorizationHeader() } }
      );
      toast.success(
        action === 'approve'
          ? 'Pengajuan disetujui, barang berhasil dihapus'
          : action === 'cancel'
          ? 'Pengajuan dibatalkan'
          : 'Pengajuan ditolak, barang dikembalikan ke etalase'
      );
      fetchDataPengajuan();
    } catch (err) {
      console.log(err);
      toast.error(err.response?.data?.message || 'Gagal memproses persetujuan');
    }
    setLoading(false);
  };

  function checkBerat(number) {
    const beratConfirm = parseFloat(number || 0);
    return beratConfirm % 1 === 0
      ? beratConfirm.toString()
      : beratConfirm
          .toFixed(2)
          .replace(/\.?0+$/, '')
          .replace('.', ',');
  }

  function showDetailItem(item) {
    setDetailItem(item);
    setOpenDetail(true);
  }

  const handleResetFilter = () => {
    setStartDate(null);
    setEndDate(null);
    setStatusFilter('');
    setCabangFilter('');
    setOperatorFilter('');
    setSearchQuery('');
    setCurrentPage(1);
    setBarangCurrentPage(1);
    setIsDateOpen(false);
  };

  const handleReload = () => {
    if (activeTab === 'pengajuan') {
      fetchDataPengajuan();
    } else {
      fetchDataBarang(barangCurrentPage);
    }
  };

  const activeFilters = useMemo(() => {
    const list = [];
    if (startDate && endDate) {
      list.push({
        id: 'date',
        label: `${moment(startDate).format('DD MMM YYYY')} - ${moment(endDate).format('DD MMM YYYY')}`,
        icon: '📅',
        onClear: () => {
          setStartDate(null);
          setEndDate(null);
          setCurrentPage(1);
          setBarangCurrentPage(1);
        },
      });
    }
    if (statusFilter) {
      const statusMap = {
        pending_approval: 'Menunggu',
        approved: 'Disetujui',
        rejected: 'Ditolak',
        cancelled: 'Dibatalkan',
      };
      list.push({
        id: 'status',
        label: statusMap[statusFilter] || statusFilter,
        icon: '⚡',
        onClear: () => {
          setStatusFilter('');
          setCurrentPage(1);
          setBarangCurrentPage(1);
        },
      });
    }
    if (cabangFilter) {
      list.push({
        id: 'cabang',
        label: `Cabang: ${cabangFilter}`,
        icon: '🏪',
        onClear: () => {
          setCabangFilter('');
          setCurrentPage(1);
          setBarangCurrentPage(1);
        },
      });
    }
    if (operatorFilter) {
      list.push({
        id: 'operator',
        label: `Operator: ${operatorFilter}`,
        icon: '👤',
        onClear: () => {
          setOperatorFilter('');
          setCurrentPage(1);
          setBarangCurrentPage(1);
        },
      });
    }
    return list;
  }, [startDate, endDate, statusFilter, cabangFilter, operatorFilter]);

  const activeFilterCount = activeFilters.length;

  // Options for Cabang and Operator from data
  const cabangOptions = useMemo(() => {
    const list = new Set();
    data.forEach((d) => {
      if (d.cabang?.nama_cabang) list.add(d.cabang.nama_cabang);
    });
    barangData.forEach((b) => {
      const cName = b.pengajuan?.cabang?.nama_cabang || b.item?.cabang?.nama_cabang;
      if (cName) list.add(cName);
    });
    return Array.from(list);
  }, [data, barangData]);

  const operatorOptions = useMemo(() => {
    const list = new Set();
    data.forEach((d) => {
      const name = d.diajukan_oleh?.name || d.user_pemohon?.name;
      if (name) list.add(name);
    });
    barangData.forEach((b) => {
      const name = b.pengajuan?.diajukan_oleh?.name || b.pengajuan?.user_pemohon?.name;
      if (name) list.add(name);
    });
    return Array.from(list);
  }, [data, barangData]);

  // Filtered Data based on dropdowns & search query
  const filteredData = useMemo(() => {
    return data.filter((item) => {
      if (statusFilter) {
        if (statusFilter === 'approved' && item.status_pengajuan !== 'direct_deleted' && item.status_pengajuan !== 'approved') {
          return false;
        } else if (statusFilter === 'cancelled' && item.status_pengajuan !== 'dibatalkan' && item.status_pengajuan !== 'cancelled') {
          return false;
        } else if (statusFilter !== 'approved' && statusFilter !== 'cancelled' && item.status_pengajuan !== statusFilter) {
          return false;
        }
      }
      if (cabangFilter && item.cabang?.nama_cabang !== cabangFilter) {
        return false;
      }
      if (operatorFilter) {
        const name = item.diajukan_oleh?.name || item.user_pemohon?.name;
        if (name !== operatorFilter) return false;
      }
      if (searchQuery.trim()) {
        const q = searchQuery.toLowerCase();
        const batch = item.batch_id ? item.batch_id.toLowerCase() : '';
        const pemohon = item.diajukan_oleh?.name ? item.diajukan_oleh.name.toLowerCase() : '';
        const cabang = item.cabang?.nama_cabang ? item.cabang.nama_cabang.toLowerCase() : '';
        if (!batch.includes(q) && !pemohon.includes(q) && !cabang.includes(q)) {
          return false;
        }
      }
      return true;
    });
  }, [data, statusFilter, cabangFilter, operatorFilter, searchQuery]);

  // Pagination for Pengajuan Table
  const totalPages = Math.ceil(filteredData.length / itemsPerPage) || 1;
  const paginatedData = useMemo(() => {
    return filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  }, [filteredData, currentPage, itemsPerPage]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleBarangPageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalBarangPages) {
      setBarangCurrentPage(newPage);
    }
  };

  // Open Detail Modal Helper
  const handleOpenDetailModal = (pengajuan, defaultTab = 'ringkasan') => {
    setSelectedPengajuan(pengajuan);
    setModalTab(defaultTab);
    setSearchModalItem('');
    setIsOpenDetailModal(true);
  };

  // Helper to render Status Badge exactly like the image
  const renderStatus = (status) => {
    if (status === 'pending_approval' || status === 'pending') {
      return (
        <span className="px-2.5 py-1 rounded border border-amber-500 text-amber-600 bg-amber-50/50 text-[11px] font-bold">
          Menunggu
        </span>
      );
    }
    if (status === 'approved' || status === 'direct_deleted') {
      return (
        <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded border border-emerald-300 bg-emerald-100 text-emerald-700 text-[11px] font-bold">
          <IconCheck size={14} stroke={3} /> Disetujui
        </span>
      );
    }
    if (status === 'rejected') {
      return (
        <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded border border-red-300 bg-red-100 text-red-700 text-[11px] font-bold">
          <IconX size={14} stroke={3} /> Ditolak
        </span>
      );
    }
    if (status === 'cancelled' || status === 'dibatalkan') {
      return (
        <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded border border-slate-300 bg-slate-100 text-slate-700 text-[11px] font-bold">
          <IconX size={14} stroke={3} /> Dibatalkan
        </span>
      );
    }
    return <span>{status}</span>;
  };

  if (!isVerifikasi && !isOperatorToko) {
    return null;
  }

  return (
    <Layouts 
    //title={isVerifikasi ? "Verifikasi Pengajuan Hapus Etalase" : "Status Pengajuan Hapus Barang"}
    >
      <DetailItem
        checkBerat={checkBerat}
        detailItem={detailItem}
        closeModalDetail={() => setOpenDetail(false)}
        openDetail={openDetail}
      />

      <div className="p-4 sm:p-6 w-full space-y-6 min-h-[75vh]">
        {/* Modern 3-Tier Filter Toolbar */}
        <div className="bg-white dark:bg-slate-900 p-3 sm:p-4 rounded-xl shadow-sm border border-slate-200 dark:border-slate-800 space-y-3">
          {/* Row 1: Search & Action Buttons */}
          <div className="flex items-center gap-1.5 sm:gap-2 w-full">
            {/* Dominant Search Input */}
            <div className="relative flex-1 min-w-0">
              <IconSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={18} />
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                  setCurrentPage(1);
                  setBarangCurrentPage(1);
                }}
                placeholder={
                  activeTab === 'pengajuan'
                    ? 'Cari No. Request, Pemohon, Toko...'
                    : 'Cari Barcode, Nama Barang, No. Request...'
                }
                className="w-full pl-9 pr-8 py-2 text-xs sm:text-sm bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-lg text-slate-800 dark:text-slate-100 placeholder-slate-400 outline-none focus:border-amber-400 focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-900/30 transition-all shadow-xs"
              />
              {searchQuery && (
                <button
                  type="button"
                  onClick={() => {
                    setSearchQuery('');
                    setCurrentPage(1);
                    setBarangCurrentPage(1);
                  }}
                  className="absolute right-2.5 top-1/2 -translate-y-1/2 p-0.5 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 rounded-full cursor-pointer"
                  title="Hapus pencarian"
                >
                  <IconX size={14} />
                </button>
              )}
            </div>

            {/* Filter Toggle Button */}
            <button
              type="button"
              onClick={() => setIsFilterOpen(!isFilterOpen)}
              className={`flex items-center gap-1.5 px-2.5 sm:px-3 py-2 rounded-lg text-xs sm:text-sm font-semibold border transition-all shrink-0 cursor-pointer shadow-xs ${
                isFilterOpen || activeFilterCount > 0
                  ? 'bg-amber-500 border-amber-600 text-white shadow-amber-500/20'
                  : 'bg-white dark:bg-slate-800 border-slate-200 dark:border-slate-600 text-slate-700 dark:text-slate-200 hover:border-amber-300 dark:hover:border-amber-500'
              }`}
              title={isFilterOpen ? 'Tutup Filter' : 'Buka Filter'}
            >
              <IconAdjustmentsHorizontal size={16} />
              <span className="hidden sm:inline">Filter</span>
              {activeFilterCount > 0 && (
                <span
                  className={`px-1.5 py-0.2 text-[10px] font-bold rounded-full leading-tight ${
                    isFilterOpen || activeFilterCount > 0
                      ? 'bg-white text-amber-700'
                      : 'bg-amber-500 text-white'
                  }`}
                >
                  {activeFilterCount}
                </span>
              )}
              {isFilterOpen ? (
                <IconChevronUp size={14} className="hidden sm:inline" />
              ) : (
                <IconChevronDown size={14} className="hidden sm:inline" />
              )}
            </button>

            {/* Reload / Refresh Button */}
            <button
              type="button"
              onClick={handleReload}
              className="bg-slate-700 hover:bg-slate-800 text-white p-2 cursor-pointer rounded-lg shadow-xs hover:shadow transition-all duration-200 shrink-0"
              title="Muat Ulang Data"
            >
              <IconReload size={18} className={loading ? 'animate-spin' : ''} />
            </button>
          </div>

          {/* Row 2: Active Filter Chips Bar */}
          {activeFilterCount > 0 && (
            <div className="flex items-center gap-1.5 overflow-x-auto py-1 w-full max-w-full no-scrollbar text-xs">
              <span className="text-[11px] font-semibold text-slate-400 dark:text-slate-500 shrink-0 uppercase tracking-wider">
                Filter:
              </span>
              {activeFilters.map((flt) => (
                <div
                  key={flt.id}
                  className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-amber-50 dark:bg-amber-950/40 border border-amber-200 dark:border-amber-800/60 text-amber-800 dark:text-amber-300 font-medium whitespace-nowrap shadow-2xs shrink-0"
                >
                  <span className="text-xs">{flt.icon}</span>
                  <span className="max-w-[150px] sm:max-w-[200px] truncate">{flt.label}</span>
                  <button
                    type="button"
                    onClick={flt.onClear}
                    className="p-0.5 hover:bg-amber-200/60 dark:hover:bg-amber-800/60 rounded-full transition-colors ml-0.5 cursor-pointer text-amber-600 dark:text-amber-400"
                    title={`Hapus filter ${flt.label}`}
                  >
                    <IconX size={12} />
                  </button>
                </div>
              ))}

              <button
                type="button"
                onClick={handleResetFilter}
                className="text-[11px] font-bold text-rose-600 dark:text-rose-400 hover:underline px-2 py-0.5 rounded shrink-0 cursor-pointer whitespace-nowrap"
              >
                Reset Semua
              </button>
            </div>
          )}

          {/* Row 3: Collapsible Filter Panel */}
          {isFilterOpen && (
            <div className="p-3 sm:p-3.5 bg-slate-50 dark:bg-slate-900/60 border border-slate-200 dark:border-slate-700 rounded-xl mt-1 shadow-inner">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-2.5">
                {/* 1. Filter Tanggal */}
                <div className="relative w-full" ref={dateDropdownRef}>
                  <button
                    type="button"
                    onClick={() => setIsDateOpen(!isDateOpen)}
                    className="w-full h-9 border border-slate-200 dark:border-slate-600 rounded-lg px-2.5 text-xs sm:text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-300 dark:hover:border-amber-500 flex items-center justify-between gap-1.5 shadow-xs whitespace-nowrap"
                    title="Filter Rentang Tanggal"
                  >
                    <div className="flex items-center gap-1.5 truncate">
                      <IconCalendarTime size={15} className="text-amber-500 shrink-0" />
                      <span className="truncate">
                        {startDate && endDate
                          ? `${moment(startDate).format('DD MMM YYYY')} - ${moment(endDate).format('DD MMM YYYY')}`
                          : 'Semua Tanggal'}
                      </span>
                    </div>
                    <IconChevronDown size={14} className="text-slate-400 shrink-0" />
                  </button>

                  {isDateOpen && (
                    <div className="absolute left-0 mt-1.5 bg-white dark:bg-slate-800 shadow-2xl rounded-xl border border-slate-200 dark:border-slate-700 z-[9999] p-2 max-w-[92vw] overflow-x-auto">
                      <DateRange ranges={[selectionRange]} onChange={handleSelectDate} />
                      <div className="flex items-center justify-between p-2 border-t border-slate-200 dark:border-slate-700 mt-1">
                        {startDate && (
                          <button
                            type="button"
                            onClick={() => {
                              setStartDate(null);
                              setEndDate(null);
                              setCurrentPage(1);
                              setBarangCurrentPage(1);
                            }}
                            className="text-xs text-rose-500 hover:underline font-bold cursor-pointer"
                          >
                            Reset Tanggal
                          </button>
                        )}
                        <button
                          type="button"
                          onClick={() => setIsDateOpen(false)}
                          className="px-3 py-1 bg-amber-500 hover:bg-amber-600 text-white rounded-lg text-xs font-semibold ml-auto transition-colors cursor-pointer"
                        >
                          Tutup
                        </button>
                      </div>
                    </div>
                  )}
                </div>

                {/* 2. Status Filter */}
                <select
                  value={statusFilter}
                  onChange={(e) => {
                    setStatusFilter(e.target.value);
                    setCurrentPage(1);
                    setBarangCurrentPage(1);
                  }}
                  className="w-full h-9 border border-slate-200 dark:border-slate-600 rounded-lg px-2.5 text-xs sm:text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-300 dark:hover:border-amber-500 outline-none shadow-xs font-medium"
                >
                  <option value="">Semua Status</option>
                  <option value="pending_approval">Menunggu</option>
                  <option value="approved">Disetujui</option>
                  <option value="rejected">Ditolak</option>
                  <option value="cancelled">Dibatalkan</option>
                </select>

                {/* 3. Cabang Asal Filter */}
                <select
                  value={cabangFilter}
                  onChange={(e) => {
                    setCabangFilter(e.target.value);
                    setCurrentPage(1);
                    setBarangCurrentPage(1);
                  }}
                  className="w-full h-9 border border-slate-200 dark:border-slate-600 rounded-lg px-2.5 text-xs sm:text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-300 dark:hover:border-amber-500 outline-none shadow-xs font-medium"
                >
                  <option value="">Semua Cabang</option>
                  {cabangOptions.map((c, i) => (
                    <option key={i} value={c}>
                      {c}
                    </option>
                  ))}
                </select>

                {/* 4. Operator Filter */}
                <select
                  value={operatorFilter}
                  onChange={(e) => {
                    setOperatorFilter(e.target.value);
                    setCurrentPage(1);
                    setBarangCurrentPage(1);
                  }}
                  className="w-full h-9 border border-slate-200 dark:border-slate-600 rounded-lg px-2.5 text-xs sm:text-sm text-slate-700 dark:text-slate-200 bg-white dark:bg-slate-800 cursor-pointer hover:border-amber-300 dark:hover:border-amber-500 outline-none shadow-xs font-medium"
                >
                  <option value="">Semua Operator</option>
                  {operatorOptions.map((op, i) => (
                    <option key={i} value={op}>
                      {op}
                    </option>
                  ))}
                </select>
              </div>

              {/* Panel Footer Controls */}
              <div className="flex items-center justify-between pt-2.5 mt-2.5 border-t border-slate-200/80 dark:border-slate-700/80">
                <div className="text-xs text-slate-500 dark:text-slate-400">
                  {activeFilterCount > 0 ? `${activeFilterCount} filter aktif` : 'Tidak ada filter aktif'}
                </div>
                <div className="flex items-center gap-2">
                  {activeFilterCount > 0 && (
                    <button
                      type="button"
                      onClick={handleResetFilter}
                      className="px-2.5 py-1 text-xs font-semibold text-rose-600 hover:bg-rose-50 dark:hover:bg-rose-950/30 rounded-lg transition-colors cursor-pointer"
                    >
                      Reset Semua
                    </button>
                  )}
                  <button
                    type="button"
                    onClick={() => setIsFilterOpen(false)}
                    className="px-3 py-1 text-xs font-semibold bg-slate-200 hover:bg-slate-300 dark:bg-slate-700 dark:hover:bg-slate-600 text-slate-700 dark:text-slate-200 rounded-lg transition-colors cursor-pointer"
                  >
                    Tutup
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Tabs Navigation */}
        <div className="flex gap-4 border-b border-slate-200 dark:border-slate-700">
          <button
            onClick={() => setActiveTab('pengajuan')}
            className={`pb-3 px-4 font-semibold text-xs transition-colors relative flex items-center gap-2 ${
              activeTab === 'pengajuan'
                ? 'text-amber-600 dark:text-amber-400'
                : 'text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'
            }`}
          >
            <IconInbox size={16} />
            <span>Pengajuan Batch</span>
            <span
              className={`px-1.5 py-0.5 rounded-full text-[10px] font-bold ${
                activeTab === 'pengajuan'
                  ? 'bg-amber-100 dark:bg-amber-900/40 text-amber-700 dark:text-amber-300'
                  : 'bg-slate-100 dark:bg-slate-800 text-slate-500'
              }`}
            >
              {filteredData.length}
            </span>
            {activeTab === 'pengajuan' && (
              <span className="absolute bottom-0 left-0 w-full h-0.5 bg-amber-500 rounded-t-full"></span>
            )}
          </button>

          <button
            onClick={() => setActiveTab('barang')}
            className={`pb-3 px-4 font-semibold text-xs transition-colors relative flex items-center gap-2 ${
              activeTab === 'barang'
                ? 'text-amber-600 dark:text-amber-400'
                : 'text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'
            }`}
          >
            <IconListDetails size={16} />
            <span>Daftar Barang</span>
            {totalBarangItems > 0 && (
              <span
                className={`px-1.5 py-0.5 rounded-full text-[10px] font-bold ${
                  activeTab === 'barang'
                    ? 'bg-amber-100 dark:bg-amber-900/40 text-amber-700 dark:text-amber-300'
                    : 'bg-slate-100 dark:bg-slate-800 text-slate-500'
                }`}
              >
                {totalBarangItems}
              </span>
            )}
            {activeTab === 'barang' && (
              <span className="absolute bottom-0 left-0 w-full h-0.5 bg-amber-500 rounded-t-full"></span>
            )}
          </button>
        </div>

        {/* Tab 1: Histori Pengajuan */}
        {activeTab === 'pengajuan' && (
          <div className="bg-white dark:bg-slate-900 rounded shadow-sm border border-slate-200 dark:border-slate-800">
            <div className="overflow-x-auto">
              <table className="w-full text-xs text-left text-slate-700 dark:text-slate-300">
                <thead className="text-[11px] font-bold uppercase bg-slate-50 dark:bg-slate-800/50 border-b border-slate-200 dark:border-slate-700 text-slate-500 tracking-wider">
                  <tr>
                    <th className="px-5 py-3.5">NO.</th>
                    <th className="px-5 py-3.5">NO. REQUEST</th>
                    <th className="px-5 py-3.5">TGL REQUEST</th>
                    <th className="px-5 py-3.5">TGL TERIMA</th>
                    <th className="px-5 py-3.5">CABANG ASAL</th>
                    <th className="px-5 py-3.5">PEMOHON</th>
                    <th className="px-5 py-3.5">VERIFIKATOR</th>
                    <th className="px-5 py-3.5">TOTAL BARANG</th>
                    <th className="px-5 py-3.5 text-center">STATUS</th>
                    <th className="px-5 py-3.5 text-center">AKSI VERIFIKASI</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100 dark:divide-slate-700/50">
                  {loading ? (
                    <tr>
                      <td colSpan="10" className="text-center py-16">
                        <div className="flex flex-col items-center justify-center gap-3">
                          <span className="loading loading-spinner loading-lg text-amber-500"></span>
                          <p className="text-slate-400 text-xs animate-pulse">Memuat data pengajuan...</p>
                        </div>
                      </td>
                    </tr>
                  ) : paginatedData.length === 0 ? (
                    <tr>
                      <td colSpan="10" className="text-center py-12 text-slate-500">
                        Tidak ada riwayat pengajuan hapus barang.
                      </td>
                    </tr>
                  ) : (
                    paginatedData.map((pengajuan, idx) => {
                      const totalPcs = pengajuan.items?.length || 0;
                      const totalBerat =
                        pengajuan.items?.reduce(
                          (total, child) => total + parseFloat((child.item || child)?.berat || 0),
                          0
                        ) || 0;
                      const displayBerat = parseFloat(totalBerat).toFixed(3);
                      const isPending =
                        pengajuan.status_pengajuan === 'pending_approval' || pengajuan.status_pengajuan === 'pending';

                      return (
                        <tr
                          key={pengajuan.id}
                          onClick={() => handleOpenDetailModal(pengajuan, 'ringkasan')}
                          className="bg-white dark:bg-slate-900 hover:bg-amber-50/40 dark:hover:bg-slate-800/60 cursor-pointer transition-colors"
                        >
                          <td className="px-5 py-3.5 font-medium text-slate-500">
                            {(currentPage - 1) * itemsPerPage + idx + 1}.
                          </td>
                          <td className="px-5 py-3.5 font-mono font-bold text-amber-600 dark:text-amber-400">
                            {pengajuan.batch_id}
                          </td>
                          <td className="px-5 py-3.5 text-slate-500">
                            {moment(pengajuan.created_at).format('DD MMM YYYY, HH.mm')}
                          </td>
                          <td className="px-5 py-3.5 text-slate-500">
                            {pengajuan.status_pengajuan === 'approved' ||
                            pengajuan.status_pengajuan === 'rejected' ||
                            pengajuan.status_pengajuan === 'direct_deleted'
                              ? moment(pengajuan.updated_at).format('DD MMM YYYY, HH.mm')
                              : '-'}
                          </td>
                          <td className="px-5 py-3.5 font-bold text-slate-700 dark:text-slate-200">
                            {pengajuan.cabang?.nama_cabang || '-'}
                          </td>
                          <td className="px-5 py-3.5 text-slate-700 dark:text-slate-300">
                            {pengajuan.diajukan_oleh?.name || pengajuan.user_pemohon?.name || 'Sistem'}
                          </td>
                          <td className="px-5 py-3.5 font-semibold text-emerald-600 dark:text-emerald-400">
                            {pengajuan.disetujui_oleh?.name || pengajuan.user_verifikator?.name || '-'}
                          </td>
                          <td className="px-5 py-3.5 font-bold text-slate-800 dark:text-slate-100">
                            {totalPcs} PCS <span className="font-semibold text-slate-500">({displayBerat} gr)</span>
                          </td>
                          <td className="px-5 py-3.5 text-center">{renderStatus(pengajuan.status_pengajuan)}</td>
                          <td className="px-5 py-3.5 text-center" onClick={(e) => e.stopPropagation()}>
                            <div className="flex items-center justify-center gap-2">
                              {isVerifikasi && isPending && canVerify ? (
                                <>
                                  <button
                                    onClick={() => confirmAction(pengajuan.id, 'approve')}
                                    className="px-2.5 py-1 bg-emerald-50 text-emerald-600 border border-emerald-200 rounded hover:bg-emerald-100 flex items-center gap-1 font-medium transition-colors text-xs cursor-pointer"
                                    title="Setujui Pengajuan"
                                  >
                                    <IconCheck size={14} /> Terima
                                  </button>
                                  <button
                                    onClick={() => confirmAction(pengajuan.id, 'reject')}
                                    className="px-2.5 py-1 bg-red-50 text-red-600 border border-red-200 rounded hover:bg-red-100 flex items-center gap-1 font-medium transition-colors text-xs cursor-pointer"
                                    title="Tolak Pengajuan"
                                  >
                                    <IconX size={14} /> Tolak
                                  </button>
                                </>
                              ) : !isVerifikasi && isPending && !canVerify ? (
                                <button
                                  onClick={() => confirmAction(pengajuan.id, 'cancel')}
                                  className="px-2.5 py-1 bg-slate-50 text-slate-600 border border-slate-200 rounded hover:bg-slate-100 flex items-center gap-1 font-medium transition-colors text-xs cursor-pointer"
                                  title="Batalkan Pengajuan"
                                >
                                  <IconX size={14} /> Batalkan
                                </button>
                              ) : null}
                              <button
                                type="button"
                                onClick={() => handleOpenDetailModal(pengajuan, 'ringkasan')}
                                className="text-amber-500 hover:text-amber-600 p-1.5 hover:bg-amber-50 dark:hover:bg-amber-900/30 rounded-lg transition-colors cursor-pointer"
                                title="Lihat Detail Permohonan"
                              >
                                <IconEye size={18} stroke={2.5} />
                              </button>
                              <button
                                type="button"
                                onClick={() => handleOpenDetailModal(pengajuan, 'galeri')}
                                className="text-amber-500 hover:text-amber-600 p-1.5 bg-amber-50 dark:bg-amber-900/30 rounded-lg border border-amber-200/60 dark:border-amber-800 hover:bg-amber-100 transition-colors cursor-pointer"
                                title="Lihat Galeri Foto"
                              >
                                <IconPhoto size={18} stroke={2.5} />
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination Controls */}
            {totalPages > 1 && (
              <div className="flex flex-col sm:flex-row items-center justify-between gap-3 px-4 py-3 border-t border-slate-200 dark:border-slate-700 bg-slate-50/50 dark:bg-slate-800/50">
                <span className="text-xs text-slate-500 dark:text-slate-400">
                  Menampilkan {(currentPage - 1) * itemsPerPage + 1} -{' '}
                  {Math.min(currentPage * itemsPerPage, filteredData.length)} dari {filteredData.length} pengajuan
                </span>
                <div className="flex items-center gap-1">
                  <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className="px-2.5 py-1 text-xs font-medium border border-slate-200 dark:border-slate-700 rounded text-slate-600 dark:text-slate-300 hover:bg-white dark:hover:bg-slate-700 disabled:opacity-40 disabled:cursor-not-allowed transition-all"
                  >
                    Prev
                  </button>
                  <span className="px-3 text-xs font-bold text-slate-700 dark:text-slate-200">
                    {currentPage} / {totalPages}
                  </span>
                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className="px-2.5 py-1 text-xs font-medium border border-slate-200 dark:border-slate-700 rounded text-slate-600 dark:text-slate-300 hover:bg-white dark:hover:bg-slate-700 disabled:opacity-40 disabled:cursor-not-allowed transition-all"
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Tab 2: Histori Barang */}
        {activeTab === 'barang' && (
          <div className="bg-white dark:bg-slate-900 rounded shadow-sm border border-slate-200 dark:border-slate-800">
            <div className="overflow-x-auto">
              <table className="w-full text-xs text-left text-slate-700 dark:text-slate-300">
                <thead className="text-[11px] font-bold uppercase bg-slate-50 dark:bg-slate-800/50 border-b border-slate-200 dark:border-slate-700 text-slate-500 tracking-wider">
                  <tr>
                    <th className="px-5 py-3.5">NO.</th>
                    <th className="px-5 py-3.5">NO. REQUEST</th>
                    <th className="px-5 py-3.5">TGL REQUEST</th>
                    <th className="px-5 py-3.5">TGL TERIMA</th>
                    <th className="px-5 py-3.5">KODE BARANG</th>
                    <th className="px-5 py-3.5">KATEGORI</th>
                    <th className="px-5 py-3.5 text-right">BERAT</th>
                    <th className="px-5 py-3.5 text-center">STATUS</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100 dark:divide-slate-700/50">
                  {loading ? (
                    <tr>
                      <td colSpan="8" className="text-center py-16">
                        <div className="flex flex-col items-center justify-center gap-3">
                          <span className="loading loading-spinner loading-lg text-amber-500"></span>
                          <p className="text-slate-400 text-xs animate-pulse">Memuat data barang...</p>
                        </div>
                      </td>
                    </tr>
                  ) : barangData.length === 0 ? (
                    <tr>
                      <td colSpan="8" className="px-6 py-12 text-center text-slate-500">
                        Belum ada histori barang
                      </td>
                    </tr>
                  ) : (
                    barangData.map((child, idx) => {
                      const bt = child.item;
                      const parent = child.pengajuan;
                      const tglRequest = child.created_at || parent?.created_at
                        ? moment(child.created_at || parent?.created_at).format('DD MMM YYYY, HH.mm')
                        : '-';
                      const tglTerima =
                        parent?.status_pengajuan === 'approved' ||
                        parent?.status_pengajuan === 'rejected' ||
                        parent?.status_pengajuan === 'direct_deleted'
                          ? moment(parent?.updated_at || child.updated_at).format('DD MMM YYYY, HH.mm')
                          : '-';

                      return (
                        <tr
                          key={child.id || idx}
                          onClick={() => {
                            if (bt) {
                              showDetailItem(bt);
                            } else if (parent) {
                              handleOpenDetailModal(parent, 'ringkasan');
                            }
                          }}
                          className="bg-white dark:bg-slate-900 hover:bg-amber-50/40 dark:hover:bg-slate-800/60 cursor-pointer transition-colors"
                        >
                          <td className="px-5 py-3.5 font-medium text-slate-500">
                            {(barangFrom ? barangFrom + idx : (barangCurrentPage - 1) * barangItemsPerPage + idx + 1)}.
                          </td>
                          <td className="px-5 py-3.5 font-mono font-bold text-amber-600 dark:text-amber-400">
                            {parent?.batch_id || '-'}
                          </td>
                          <td className="px-5 py-3.5 text-slate-500">
                            {tglRequest}
                          </td>
                          <td className="px-5 py-3.5 text-slate-500">
                            {tglTerima}
                          </td>
                          <td className="px-5 py-3.5 font-bold text-slate-800 dark:text-slate-200">
                            {bt?.kode_item || 'Item Terhapus'}
                          </td>
                          <td className="px-5 py-3.5 text-slate-600 dark:text-slate-300">
                            {bt?.jenis_kategori?.nama_jenis || '-'}
                          </td>
                          <td className="px-5 py-3.5 text-right font-semibold text-slate-800 dark:text-slate-100">
                            {bt?.berat !== undefined && bt?.berat !== null ? `${parseFloat(bt.berat || 0).toFixed(3)} gr` : '-'}
                          </td>
                          <td className="px-5 py-3.5 text-center">
                            {renderStatus(parent?.status_pengajuan)}
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination Controls */}
            {totalBarangPages > 1 && (
              <div className="flex flex-col sm:flex-row items-center justify-between gap-3 px-4 py-3 border-t border-slate-200 dark:border-slate-700 bg-slate-50/50 dark:bg-slate-800/50">
                <p className="text-xs text-slate-500">
                  Menampilkan{' '}
                  <span className="font-semibold text-slate-700 dark:text-slate-200">
                    {barangFrom || (totalBarangItems > 0 ? (barangCurrentPage - 1) * barangItemsPerPage + 1 : 0)}
                  </span>{' '}
                  sampai{' '}
                  <span className="font-semibold text-slate-700 dark:text-slate-200">
                    {barangTo || Math.min(barangCurrentPage * barangItemsPerPage, totalBarangItems)}
                  </span>{' '}
                  dari{' '}
                  <span className="font-semibold text-slate-700 dark:text-slate-200">
                    {totalBarangItems}
                  </span>{' '}
                  barang
                </p>
                <div className="flex items-center gap-1">
                  <button
                    onClick={() => handleBarangPageChange(barangCurrentPage - 1)}
                    disabled={barangCurrentPage === 1}
                    className="px-2.5 py-1 text-xs font-medium border border-slate-200 dark:border-slate-700 rounded text-slate-600 dark:text-slate-300 hover:bg-white dark:hover:bg-slate-700 disabled:opacity-40 disabled:cursor-not-allowed transition-all"
                  >
                    Prev
                  </button>
                  <span className="px-3 text-xs font-bold text-slate-700 dark:text-slate-200">
                    {barangCurrentPage} / {totalBarangPages}
                  </span>
                  <button
                    onClick={() => handleBarangPageChange(barangCurrentPage + 1)}
                    disabled={barangCurrentPage === totalBarangPages}
                    className="px-2.5 py-1 text-xs font-medium border border-slate-200 dark:border-slate-700 rounded text-slate-600 dark:text-slate-300 hover:bg-white dark:hover:bg-slate-700 disabled:opacity-40 disabled:cursor-not-allowed transition-all"
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Detail Items Modal (5 Tabs Identik seperti Pindah Pusat) */}
      {isOpenDetailModal && selectedPengajuan && (() => {
        const userPemohon =
          selectedPengajuan.diajukan_oleh ||
          selectedPengajuan.user_pemohon ||
          selectedPengajuan.userPemohon ||
          selectedPengajuan.user;
        const userVerifikator =
          selectedPengajuan.disetujui_oleh ||
          selectedPengajuan.user_verifikator ||
          selectedPengajuan.userVerifikator;
        const totalPcs = selectedPengajuan.items?.length || 0;
        const totalBerat =
          selectedPengajuan.items?.reduce(
            (total, child) => total + parseFloat((child.item || child)?.berat || 0),
            0
          ) || 0;
        const isPending =
          selectedPengajuan.status_pengajuan === 'pending_approval' || selectedPengajuan.status_pengajuan === 'pending';
        const isApproved =
          selectedPengajuan.status_pengajuan === 'approved' ||
          selectedPengajuan.status_pengajuan === 'direct_deleted';
        const isCancelled =
          selectedPengajuan.status_pengajuan === 'cancelled' ||
          selectedPengajuan.status_pengajuan === 'dibatalkan';
        const isRejected = selectedPengajuan.status_pengajuan === 'rejected';

        return (
          <div
            className="fixed inset-0 z-[999] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4"
            onClick={() => setIsOpenDetailModal(false)}
          >
            <div
              className="bg-white dark:bg-slate-800 w-full max-w-4xl lg:max-w-5xl rounded-md p-5 md:p-6 shadow-2xl border border-slate-200 dark:border-slate-700 max-h-[92vh] flex flex-col space-y-4"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Modal Header */}
              <div className="flex items-center justify-between border-b border-slate-100 dark:border-slate-700 pb-3 flex-shrink-0">
                <div>
                  <div className="flex items-center gap-2">
                    <h3 className="font-bold text-sm md:text-base text-slate-800 dark:text-slate-100">
                      Detail Permohonan: <span className="font-mono text-amber-600">{selectedPengajuan.batch_id}</span>
                    </h3>
                    {isPending ? (
                      <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-amber-100 text-amber-700 dark:bg-amber-950/60 dark:text-amber-300 rounded-md border border-amber-300 dark:border-amber-700 text-[11px] font-bold">
                        Menunggu
                      </span>
                    ) : isApproved ? (
                      <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-emerald-100 text-emerald-700 dark:bg-emerald-950/60 dark:text-emerald-300 rounded-md border border-emerald-300 dark:border-emerald-700 text-[11px] font-bold">
                        ✓ Disetujui
                      </span>
                    ) : isCancelled ? (
                      <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300 rounded-md border border-slate-300 text-[11px] font-bold">
                        Dibatalkan
                      </span>
                    ) : (
                      <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-rose-100 text-rose-700 dark:bg-rose-950/60 dark:text-rose-300 rounded-md border border-rose-300 dark:border-rose-700 text-[11px] font-bold">
                        ✕ Ditolak
                      </span>
                    )}
                  </div>
                  <div className="flex flex-wrap gap-x-4 gap-y-1 text-[11px] text-slate-500 mt-1">
                    <span>
                      <strong className="text-slate-600 dark:text-slate-400">Request:</strong>{' '}
                      {new Date(selectedPengajuan.created_at).toLocaleString('id-ID', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                      })}
                    </span>
                    {!isPending && selectedPengajuan.updated_at && (
                      <span>
                        <strong className="text-slate-600 dark:text-slate-400">Verifikasi:</strong>{' '}
                        {new Date(selectedPengajuan.updated_at).toLocaleString('id-ID', {
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit',
                        })}
                      </span>
                    )}
                  </div>
                </div>
                <button
                  type="button"
                  onClick={() => setIsOpenDetailModal(false)}
                  className="p-1.5 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-lg transition-colors cursor-pointer"
                >
                  <IconX size={20} />
                </button>
              </div>

              {/* Top Quick Info Strip */}
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 text-xs bg-slate-50 dark:bg-slate-700/40 p-3 rounded-xl flex-shrink-0">
                <div>
                  <span className="text-slate-400 block text-[10px]">Toko Asal (Etalase)</span>
                  <span className="font-bold text-slate-800 dark:text-slate-200 truncate block">
                    {selectedPengajuan.cabang?.nama_cabang || '-'}
                  </span>
                </div>
                <div>
                  <span className="text-slate-400 block text-[10px]">Operator Pemohon</span>
                  <span className="font-bold text-slate-800 dark:text-slate-200 truncate block">
                    {userPemohon?.name || 'Sistem'}
                  </span>
                </div>
                <div>
                  <span className="text-slate-400 block text-[10px]">Total Item & Berat</span>
                  <span className="font-bold text-slate-800 dark:text-slate-200 truncate block">
                    {totalPcs} PCS
                    <span className="text-amber-600 dark:text-amber-400 font-semibold ml-1">
                      ({parseFloat(totalBerat).toFixed(3)} gr)
                    </span>
                  </span>
                </div>
                <div>
                  <span className="text-slate-400 block text-[10px]">Verifikator</span>
                  <span className="font-bold text-emerald-600 dark:text-emerald-400 truncate block">
                    {userVerifikator?.name ||
                      (isPending ? 'Menunggu...' : isCancelled ? 'Dibatalkan' : '-')}
                  </span>
                </div>
              </div>

              {/* 5 Tab Navigation Bar */}
              <div className="flex border-b border-slate-200 dark:border-slate-700 gap-1 overflow-x-auto scrollbar-none flex-shrink-0">
                <button
                  type="button"
                  onClick={() => setModalTab('ringkasan')}
                  className={`px-3 py-2 text-xs font-bold flex items-center gap-1.5 border-b-2 transition-all whitespace-nowrap cursor-pointer ${
                    modalTab === 'ringkasan'
                      ? 'border-amber-500 text-amber-600 dark:text-amber-400 bg-amber-50/50 dark:bg-amber-900/10'
                      : 'border-transparent text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'
                  }`}
                >
                  <IconChartPie size={16} />
                  <span>Ringkasan Item</span>
                </button>
                <button
                  type="button"
                  onClick={() => setModalTab('list')}
                  className={`px-3 py-2 text-xs font-bold flex items-center gap-1.5 border-b-2 transition-all whitespace-nowrap cursor-pointer ${
                    modalTab === 'list'
                      ? 'border-amber-500 text-amber-600 dark:text-amber-400 bg-amber-50/50 dark:bg-amber-900/10'
                      : 'border-transparent text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'
                  }`}
                >
                  <IconListDetails size={16} />
                  <span>List Item ({modalItemList.length})</span>
                </button>
                <button
                  type="button"
                  onClick={() => setModalTab('operator')}
                  className={`px-3 py-2 text-xs font-bold flex items-center gap-1.5 border-b-2 transition-all whitespace-nowrap cursor-pointer ${
                    modalTab === 'operator'
                      ? 'border-amber-500 text-amber-600 dark:text-amber-400 bg-amber-50/50 dark:bg-amber-900/10'
                      : 'border-transparent text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'
                  }`}
                >
                  <IconUser size={16} />
                  <span>Operator Pemohon</span>
                </button>
                <button
                  type="button"
                  onClick={() => setModalTab('verifikator')}
                  className={`px-3 py-2 text-xs font-bold flex items-center gap-1.5 border-b-2 transition-all whitespace-nowrap cursor-pointer ${
                    modalTab === 'verifikator'
                      ? 'border-amber-500 text-amber-600 dark:text-amber-400 bg-amber-50/50 dark:bg-amber-900/10'
                      : 'border-transparent text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'
                  }`}
                >
                  <IconCircleCheck size={16} />
                  <span>Verifikator</span>
                </button>
                <button
                  type="button"
                  onClick={() => setModalTab('galeri')}
                  className={`px-3 py-2 text-xs font-bold flex items-center gap-1.5 border-b-2 transition-all whitespace-nowrap cursor-pointer ${
                    modalTab === 'galeri'
                      ? 'border-amber-500 text-amber-600 dark:text-amber-400 bg-amber-50/50 dark:bg-amber-900/10'
                      : 'border-transparent text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'
                  }`}
                >
                  <IconPhoto size={16} />
                  <span>Galeri List Item</span>
                </button>
              </div>

              {/* Scrollable Tab Content */}
              <div className="flex-1 overflow-y-auto pr-1">
                {/* 1. Tab Ringkasan Item */}
                {modalTab === 'ringkasan' && (() => {
                  const itemsList = selectedPengajuan.items || [];
                  const totalPcsVal = totalPcs || itemsList.length;
                  const totalBeratVal = parseFloat(totalBerat || itemsList.reduce((acc, it) => acc + parseFloat((it.item || it)?.berat || 0), 0));
                  const avgBeratVal = itemsList.length > 0 ? (totalBeratVal / itemsList.length) : (totalPcsVal > 0 ? totalBeratVal / totalPcsVal : 0);
                  const validModalItems = itemsList.filter(it => Number((it.item || it)?.harga_modal || 0) > 0);
                  const avgModalVal = validModalItems.length > 0
                    ? Math.round(validModalItems.reduce((acc, it) => acc + Number((it.item || it)?.harga_modal || 0), 0) / validModalItems.length)
                    : 0;
                  const maxBeratVal = itemsList.length > 0 ? Math.max(...itemsList.map(it => parseFloat((it.item || it)?.berat || 0) || 0)) : 0;
                  const maxModalVal = itemsList.length > 0 ? Math.max(...itemsList.map(it => Number((it.item || it)?.harga_modal || 0) || 0)) : 0;

                  return (
                    <div className="space-y-4">
                      {/* Ringkasan Cards (7 Cards) */}
                      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2.5 sm:gap-3">
                        <div className="bg-amber-50/60 dark:bg-amber-950/20 border border-amber-200/70 dark:border-amber-900/40 rounded-xl p-3">
                          <span className="text-amber-700 dark:text-amber-400 text-[10px] font-bold uppercase tracking-wider block">Total Barang</span>
                          <div className="text-lg font-extrabold text-slate-800 dark:text-slate-100 mt-0.5">
                            {totalPcsVal} <span className="text-xs font-semibold text-slate-500">Pcs</span>
                          </div>
                        </div>
                        <div className="bg-amber-50/60 dark:bg-amber-950/20 border border-amber-200/70 dark:border-amber-900/40 rounded-xl p-3">
                          <span className="text-amber-700 dark:text-amber-400 text-[10px] font-bold uppercase tracking-wider block">Total Berat</span>
                          <div className="text-lg font-extrabold text-amber-600 dark:text-amber-400 mt-0.5 font-mono">
                            {totalBeratVal.toFixed(3)} <span className="text-xs font-semibold text-slate-500 font-sans">gr</span>
                          </div>
                        </div>
                        <div className="bg-slate-50 dark:bg-slate-700/30 border border-slate-200 dark:border-slate-700 rounded-xl p-3">
                          <span className="text-slate-500 text-[10px] font-bold uppercase tracking-wider block">Total Kategori</span>
                          <div className="text-lg font-extrabold text-slate-800 dark:text-slate-100 mt-0.5">
                            {Object.keys(detailSummary).length} <span className="text-xs font-semibold text-slate-500">Kategori</span>
                          </div>
                        </div>
                        <div className="bg-slate-50 dark:bg-slate-700/30 border border-slate-200 dark:border-slate-700 rounded-xl p-3">
                          <span className="text-slate-500 text-[10px] font-bold uppercase tracking-wider block">Rata-rata Berat</span>
                          <div className="text-lg font-extrabold text-slate-800 dark:text-slate-100 mt-0.5 font-mono">
                            {avgBeratVal.toFixed(3)} <span className="text-xs font-semibold text-slate-500 font-sans">gr</span>
                          </div>
                        </div>
                        <div className="bg-slate-50 dark:bg-slate-700/30 border border-slate-200 dark:border-slate-700 rounded-xl p-3">
                          <span className="text-slate-500 text-[10px] font-bold uppercase tracking-wider block">Rata-rata Modal</span>
                          <div className="text-lg font-extrabold text-slate-800 dark:text-slate-100 mt-0.5 font-mono">
                            Rp {avgModalVal.toLocaleString('id-ID')}
                          </div>
                        </div>
                        <div className="bg-slate-50 dark:bg-slate-700/30 border border-slate-200 dark:border-slate-700 rounded-xl p-3">
                          <span className="text-slate-500 text-[10px] font-bold uppercase tracking-wider block">Berat Maksimal</span>
                          <div className="text-lg font-extrabold text-slate-800 dark:text-slate-100 mt-0.5 font-mono">
                            {maxBeratVal.toFixed(3)} <span className="text-xs font-semibold text-slate-500 font-sans">gr</span>
                          </div>
                        </div>
                        <div className="bg-slate-50 dark:bg-slate-700/30 border border-slate-200 dark:border-slate-700 rounded-xl p-3">
                          <span className="text-slate-500 text-[10px] font-bold uppercase tracking-wider block">Modal Maksimal</span>
                          <div className="text-lg font-extrabold text-slate-800 dark:text-slate-100 mt-0.5 font-mono">
                            Rp {maxModalVal.toLocaleString('id-ID')}
                          </div>
                        </div>
                      </div>

                    {/* Breakdown Kategori & Karat */}
                    {Object.keys(detailSummary).length > 0 && (
                      <div className="space-y-3 p-3.5 bg-amber-50/50 dark:bg-amber-900/10 border border-amber-200/50 dark:border-amber-900/30 rounded-xl">
                        <div className="flex items-center justify-between">
                          <h4 className="text-[11px] font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider flex items-center gap-1.5">
                            <IconChartPie size={16} />
                            <span>Breakdown Per Kategori & Karat</span>
                          </h4>
                          <span className="text-[10px] text-amber-700 dark:text-amber-400 font-semibold">
                            {Object.keys(detailSummary).length} Kategori
                          </span>
                        </div>
                        <div className="space-y-2">
                          {Object.values(detailSummary).map((cat, idx) => (
                            <div
                              key={idx}
                              className="bg-white dark:bg-slate-800 p-3 rounded-xl border border-amber-200/60 dark:border-slate-700 shadow-sm"
                            >
                              <div className="flex justify-between items-center mb-2 pb-2 border-b border-slate-100 dark:border-slate-700">
                                <span className="font-bold text-slate-800 dark:text-slate-100 text-sm">{cat.name}</span>
                                <span className="font-bold text-amber-600 dark:text-amber-400 text-xs bg-amber-50 dark:bg-amber-900/30 border border-amber-200 dark:border-amber-800 px-2.5 py-0.5 rounded-md">
                                  {cat.pcs} Pcs ({cat.berat.toFixed(3)} gr)
                                </span>
                              </div>
                              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2">
                                {Object.entries(cat.byKarat).map(([karat, val], i) => (
                                  <div
                                    key={i}
                                    className="flex items-center justify-between bg-slate-50 dark:bg-slate-700/40 px-2.5 py-1.5 rounded-lg text-xs border border-slate-100 dark:border-slate-700"
                                  >
                                    <span className="font-semibold text-slate-500 dark:text-slate-400">
                                      {karat} Karat
                                    </span>
                                    <span className="font-bold text-slate-800 dark:text-slate-100">
                                      {val.pcs} Pcs / {val.berat.toFixed(3)}g
                                    </span>
                                  </div>
                                ))}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* Catatan Area */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-1">
                      <div className="p-3 bg-slate-50 dark:bg-slate-700/30 rounded-xl border border-slate-200 dark:border-slate-700 space-y-1">
                        <span className="text-slate-400 text-[10px] font-bold uppercase tracking-wider block">
                          Alasan Pengajuan Hapus (Pemohon)
                        </span>
                        <p className="text-xs text-slate-700 dark:text-slate-300 font-medium leading-relaxed">
                          {selectedPengajuan.alasan || (
                            <span className="italic text-slate-400">Tidak ada catatan alasan dari pemohon.</span>
                          )}
                        </p>
                      </div>
                      <div className="p-3 bg-slate-50 dark:bg-slate-700/30 rounded-xl border border-slate-200 dark:border-slate-700 space-y-1">
                        <span className="text-slate-400 text-[10px] font-bold uppercase tracking-wider block">
                          {isCancelled ? 'Alasan Pembatalan' : 'Catatan Verifikator'}
                        </span>
                        <p className="text-xs text-slate-700 dark:text-slate-300 font-medium leading-relaxed">
                          {(
                            selectedPengajuan.catatan_verifikasi ||
                            selectedPengajuan.catatan_verifikator ||
                            selectedPengajuan.catatan
                          ) ? (
                            selectedPengajuan.catatan_verifikasi ||
                            selectedPengajuan.catatan_verifikator ||
                            selectedPengajuan.catatan
                          ) : (
                            <span className="italic text-slate-400">
                              {isPending
                                ? 'Menunggu pemeriksaan verifikator...'
                                : isCancelled
                                ? 'Permohonan dibatalkan oleh pemohon.'
                                : 'Tidak ada catatan atau instruksi khusus dari verifikator.'}
                            </span>
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })()}

                {/* 2. Tab List Item (Tabel) */}
                {modalTab === 'list' && (
                  <div className="space-y-3">
                    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
                      <div className="relative flex-1 max-w-xs">
                        <IconSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={15} />
                        <input
                          type="text"
                          placeholder="Cari kode, jenis, baki..."
                          value={searchModalItem}
                          onChange={(e) => setSearchModalItem(e.target.value)}
                          className="w-full pl-8 pr-3 py-1.5 text-xs bg-slate-50 dark:bg-slate-700/50 border border-slate-200 dark:border-slate-600 rounded-lg outline-none focus:border-amber-400 focus:ring-1 focus:ring-amber-200"
                        />
                      </div>
                      <span className="text-[11px] text-slate-500 font-medium">
                        Menampilkan {filteredModalItems.length} dari {modalItemList.length} item
                      </span>
                    </div>

                    <div className="border border-slate-200 dark:border-slate-700 rounded-xl overflow-x-auto max-h-80">
                      <table className="w-full text-xs text-left text-slate-600 dark:text-slate-300">
                        <thead className="bg-gradient-to-r from-amber-50 via-amber-100/80 to-amber-50 dark:from-amber-900/40 dark:via-amber-800/30 dark:to-amber-900/40 text-[11px] text-amber-800 dark:text-amber-300 uppercase border-b border-amber-200/70 dark:border-amber-800/40 sticky top-0 z-10 font-bold tracking-wider">
                          <tr>
                            <th className="p-2.5 w-10 text-center font-bold">No</th>
                            <th className="p-2.5 font-bold">Kode Barang</th>
                            <th className="p-2.5 font-bold">Nama Barang</th>
                            <th className="p-2.5 text-center font-bold">Baki / Rak</th>
                            <th className="p-2.5 text-right font-bold">Berat (gr)</th>
                            <th className="p-2.5 text-center font-bold">Karat</th>
                            <th className="p-2.5 text-center font-bold">Status</th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-100 dark:divide-slate-700/50">
                          {filteredModalItems.length === 0 ? (
                            <tr>
                              <td colSpan={7} className="text-center py-6 text-slate-400">
                                Tidak ada item yang sesuai dengan pencarian
                              </td>
                            </tr>
                          ) : (
                            filteredModalItems.map((it, idx) => (
                              <tr
                                key={it.id || idx}
                                className="hover:bg-slate-50 dark:hover:bg-slate-700/30 transition-colors"
                              >
                                <td className="p-2.5 text-slate-500 font-medium text-center">{idx + 1}.</td>
                                <td className="p-2.5 font-mono font-bold text-amber-600 dark:text-amber-400">
                                  {it.kode_item}
                                </td>
                                <td className="p-2.5">
                                  <span className="text-slate-700 dark:text-slate-300 font-medium">
                                    {it.jenis_kategori?.nama_jenis || '-'}
                                  </span>
                                </td>
                                <td className="p-2.5 text-center font-medium">{it.nomor_rak || '-'}</td>
                                <td className="p-2.5 text-right font-bold text-amber-600 dark:text-amber-400">
                                  {parseFloat(it.berat || 0).toFixed(3)} gr
                                </td>
                                <td className="p-2.5 text-center font-semibold">{it.karat} K</td>
                                <td className="p-2.5 text-center">
                                  <span
                                    className={`px-2 py-0.5 rounded text-[10px] font-bold ${
                                      it.status_item === 'approved' ||
                                      it.status_item === 'direct_deleted' ||
                                      isApproved
                                        ? 'bg-emerald-100 text-emerald-700 dark:bg-emerald-950/60 dark:text-emerald-300'
                                        : it.status_item === 'rejected' || isRejected
                                        ? 'bg-rose-100 text-rose-700 dark:bg-rose-950/60 dark:text-rose-300'
                                        : it.status_item === 'cancelled' ||
                                          it.status_item === 'dibatalkan' ||
                                          isCancelled
                                        ? 'bg-slate-100 text-slate-600 dark:bg-slate-700 dark:text-slate-300'
                                        : 'bg-amber-100 text-amber-700 dark:bg-amber-950/60 dark:text-amber-300'
                                    }`}
                                  >
                                    {it.status_item === 'approved' || it.status_item === 'direct_deleted'
                                      ? 'Disetujui'
                                      : it.status_item === 'rejected'
                                      ? 'Ditolak'
                                      : it.status_item === 'cancelled' || it.status_item === 'dibatalkan'
                                      ? 'Dibatalkan'
                                      : 'Menunggu'}
                                  </span>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                        {filteredModalItems.length > 0 && (
                          <tfoot className="bg-slate-50 dark:bg-slate-700/50 font-bold border-t border-slate-200 dark:border-slate-700 sticky bottom-0">
                            <tr>
                              <td colSpan={4} className="p-2.5 text-right text-slate-600 dark:text-slate-300">
                                Total ({filteredModalItems.length} item):
                              </td>
                              <td className="p-2.5 text-right text-amber-600 dark:text-amber-400 font-mono">
                                {filteredModalItems
                                  .reduce((acc, it) => acc + parseFloat(it.berat || 0), 0)
                                  .toFixed(3)}{' '}
                                gr
                              </td>
                              <td colSpan={2}></td>
                            </tr>
                          </tfoot>
                        )}
                      </table>
                    </div>
                  </div>
                )}

                {/* 3. Tab Operator Pemohon */}
                {modalTab === 'operator' && (
                  <div className="space-y-4">
                    <div className="bg-slate-50 dark:bg-slate-700/30 p-5 rounded-2xl border border-slate-200 dark:border-slate-700">
                      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 pb-4 border-b border-slate-200 dark:border-slate-600">
                        <div className="flex items-center gap-3.5">
                          <div className="w-12 h-12 rounded-2xl bg-amber-500/10 dark:bg-amber-400/20 text-amber-600 dark:text-amber-400 flex items-center justify-center font-bold text-lg border border-amber-200 dark:border-amber-700/50">
                            {userPemohon?.name ? userPemohon.name.charAt(0).toUpperCase() : <IconUser size={24} />}
                          </div>
                          <div>
                            <h4 className="font-bold text-base text-slate-800 dark:text-slate-100">
                              {userPemohon?.name || 'Operator Toko'}
                            </h4>
                            {userPemohon?.email && (
                              <p className="text-xs text-slate-500 dark:text-slate-400">
                                {userPemohon.email}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="flex items-center gap-2">
                          <span className="px-2.5 py-1 text-[11px] font-bold rounded-lg bg-amber-100 dark:bg-amber-900/40 text-amber-700 dark:text-amber-300 border border-amber-200 dark:border-amber-800">
                            {userPemohon?.roles
                              ? userPemohon.roles
                                  .map((r) => (typeof r === 'string' ? r : r.name).replace(/_/g, ' ').toUpperCase())
                                  .join(', ')
                              : userPemohon?.role
                              ? userPemohon.role.replace(/_/g, ' ').toUpperCase()
                              : 'OPERATOR TOKO'}
                          </span>
                          <span
                            className={`px-2.5 py-1 text-[11px] font-bold rounded-lg border ${
                              userPemohon?.is_active !== false && userPemohon?.is_active !== 0
                                ? 'bg-emerald-100 dark:bg-emerald-900/40 text-emerald-700 dark:text-emerald-300 border-emerald-200 dark:border-emerald-800'
                                : 'bg-slate-100 dark:bg-slate-800 text-slate-500 border-slate-200'
                            }`}
                          >
                            {userPemohon?.is_active !== false && userPemohon?.is_active !== 0
                              ? '● Akun Aktif'
                              : '○ Non-Aktif'}
                          </span>
                        </div>
                      </div>

                      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 pt-4 text-xs">
                        <div className="space-y-1">
                          <span className="text-slate-400 text-[11px] block">Cabang / Toko Asal</span>
                          <div className="flex items-center gap-1.5 font-bold text-slate-800 dark:text-slate-200">
                            <IconBuildingStore size={15} className="text-amber-500" />
                            <span>{selectedPengajuan.cabang?.nama_cabang || userPemohon?.cabang?.nama_cabang || '-'}</span>
                          </div>
                        </div>

                        <div className="space-y-1">
                          <span className="text-slate-400 text-[11px] block">Lokasi Toko</span>
                          <p className="font-semibold text-slate-700 dark:text-slate-300">
                            {selectedPengajuan.cabang?.lokasi || userPemohon?.cabang?.lokasi || '-'}
                          </p>
                        </div>

                        <div className="space-y-1">
                          <span className="text-slate-400 text-[11px] block">Waktu Pengajuan Permohonan</span>
                          <div className="flex items-center gap-1.5 font-semibold text-slate-700 dark:text-slate-300">
                            <IconClock size={15} className="text-slate-400" />
                            <span>{moment(selectedPengajuan.created_at).format('DD MMM YYYY, HH:mm')}</span>
                          </div>
                        </div>

                        <div className="space-y-1 sm:col-span-2 md:col-span-3 pt-2 border-t border-slate-200 dark:border-slate-600">
                          <span className="text-slate-400 text-[11px] block">Catatan yang Dilampirkan Pemohon</span>
                          <div className="p-3 bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-300 font-medium leading-relaxed">
                            {selectedPengajuan.alasan || (
                              <span className="italic text-slate-400">Tidak ada catatan khusus dari pemohon.</span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* 4. Tab Verifikator */}
                {modalTab === 'verifikator' && (
                  <div className="space-y-4">
                    {userVerifikator && !isCancelled ? (
                      <div className="bg-slate-50 dark:bg-slate-700/30 p-5 rounded-2xl border border-slate-200 dark:border-slate-700">
                        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 pb-4 border-b border-slate-200 dark:border-slate-600">
                          <div className="flex items-center gap-3.5">
                            <div className="w-12 h-12 rounded-2xl bg-emerald-500/10 dark:bg-emerald-400/20 text-emerald-600 dark:text-emerald-400 flex items-center justify-center font-bold text-lg border border-emerald-200 dark:border-emerald-700/50">
                              {userVerifikator.name ? userVerifikator.name.charAt(0).toUpperCase() : <IconCircleCheck size={24} />}
                            </div>
                            <div>
                              <h4 className="font-bold text-base text-slate-800 dark:text-slate-100">
                                {userVerifikator.name}
                              </h4>
                              {userVerifikator?.email && (
                                <p className="text-xs text-slate-500 dark:text-slate-400">
                                  {userVerifikator.email}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="flex items-center gap-2">
                            <span className="px-2.5 py-1 text-[11px] font-bold rounded-lg bg-emerald-100 dark:bg-emerald-900/40 text-emerald-700 dark:text-emerald-300 border border-emerald-200 dark:border-emerald-800">
                              {userVerifikator.roles
                                ? userVerifikator.roles
                                    .map((r) => (typeof r === 'string' ? r : r.name).replace(/_/g, ' ').toUpperCase())
                                    .join(', ')
                                : userVerifikator.role
                                ? userVerifikator.role.replace(/_/g, ' ').toUpperCase()
                                : 'VERIFIKATOR PUSAT'}
                            </span>
                            <span
                              className={`px-2.5 py-1 text-[11px] font-bold rounded-lg border ${
                                isApproved
                                  ? 'bg-emerald-100 text-emerald-700 border-emerald-300 dark:bg-emerald-950/60 dark:text-emerald-300 dark:border-emerald-700'
                                  : isRejected
                                  ? 'bg-rose-100 text-rose-700 border-rose-300 dark:bg-rose-950/60 dark:text-rose-300 dark:border-rose-700'
                                  : 'bg-slate-100 text-slate-700 border-slate-300 dark:bg-slate-800 dark:text-slate-300'
                              }`}
                            >
                              {isApproved ? '✓ Disetujui' : isRejected ? '✕ Ditolak' : selectedPengajuan.status_pengajuan}
                            </span>
                          </div>
                        </div>

                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 pt-4 text-xs">
                          <div className="space-y-1">
                            <span className="text-slate-400 text-[11px] block">Unit / Cabang Verifikator</span>
                            <div className="flex items-center gap-1.5 font-bold text-slate-800 dark:text-slate-200">
                              <IconBuildingStore size={15} className="text-emerald-500" />
                              <span>{userVerifikator.cabang?.nama_cabang || 'Kantor Pusat / Owner'}</span>
                            </div>
                          </div>

                          <div className="space-y-1">
                            <span className="text-slate-400 text-[11px] block">Waktu Verifikasi Selesai</span>
                            <div className="flex items-center gap-1.5 font-semibold text-slate-700 dark:text-slate-300">
                              <IconClock size={15} className="text-emerald-500" />
                              <span>{moment(selectedPengajuan.updated_at).format('DD MMM YYYY, HH:mm:ss')}</span>
                            </div>
                          </div>

                          <div className="space-y-1">
                            <span className="text-slate-400 text-[11px] block">Status Akun</span>
                            <span className="font-semibold text-emerald-600 dark:text-emerald-400">
                              {userVerifikator.is_active !== false && userVerifikator.is_active !== 0 ? '● Aktif' : '○ Non-Aktif'}
                            </span>
                          </div>

                          <div className="space-y-1 sm:col-span-2 md:col-span-3 pt-2 border-t border-slate-200 dark:border-slate-600">
                            <span className="text-slate-400 text-[11px] block">Catatan / Keterangan Verifikator</span>
                            <div className="p-3 bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-300 font-medium leading-relaxed">
                              {(
                                selectedPengajuan.catatan_verifikasi ||
                                selectedPengajuan.catatan_verifikator ||
                                selectedPengajuan.catatan
                              ) ? (
                                selectedPengajuan.catatan_verifikasi ||
                                selectedPengajuan.catatan_verifikator ||
                                selectedPengajuan.catatan
                              ) : (
                                <span className="italic text-slate-400">
                                  Tidak ada catatan atau instruksi khusus dari verifikator.
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : isCancelled ? (
                      <div className="p-8 text-center bg-slate-50 dark:bg-slate-700/20 rounded-2xl border border-slate-200 dark:border-slate-700 space-y-3">
                        <div className="w-12 h-12 mx-auto rounded-full bg-slate-200 dark:bg-slate-700 text-slate-500 flex items-center justify-center">
                          <IconAlertTriangle size={24} />
                        </div>
                        <h4 className="font-bold text-sm text-slate-800 dark:text-slate-100">
                          Permohonan Telah Dibatalkan
                        </h4>
                        <p className="text-xs text-slate-500 dark:text-slate-400 max-w-md mx-auto">
                          Permohonan pengajuan hapus etalase ini telah dibatalkan sebelum diproses oleh Admin / Verifikator.
                        </p>
                      </div>
                    ) : (
                      <div className="p-8 text-center bg-amber-50/50 dark:bg-amber-900/10 rounded-2xl border border-amber-200/60 dark:border-amber-900/30 space-y-3">
                        <div className="w-12 h-12 mx-auto rounded-full bg-amber-100 dark:bg-amber-900/40 text-amber-600 dark:text-amber-400 flex items-center justify-center">
                          <IconClock size={24} />
                        </div>
                        <h4 className="font-bold text-sm text-amber-800 dark:text-amber-300">Menunggu Verifikator</h4>
                        <p className="text-xs text-slate-600 dark:text-slate-400 max-w-md mx-auto">
                          Permohonan ini berstatus <strong className="text-amber-700 dark:text-amber-400">Menunggu Persetujuan</strong> dan sedang dalam antrean pemeriksaan oleh tim Admin Pusat / Owner / Verifikator. Informasi detail akun verifikator akan muncul secara otomatis setelah pengajuan disetujui atau ditolak.
                        </p>
                      </div>
                    )}
                  </div>
                )}

                {/* 5. Tab Galeri List Item */}
                {modalTab === 'galeri' && (
                  <div className="space-y-4">
                    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
                      <div className="relative flex-1 max-w-xs">
                        <IconSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={15} />
                        <input
                          type="text"
                          placeholder="Cari kode, jenis, baki..."
                          value={searchModalItem}
                          onChange={(e) => setSearchModalItem(e.target.value)}
                          className="w-full pl-8 pr-3 py-1.5 text-xs bg-slate-50 dark:bg-slate-700/50 border border-slate-200 dark:border-slate-600 rounded-lg outline-none focus:border-amber-400 focus:ring-1 focus:ring-amber-200"
                        />
                      </div>
                      <span className="text-[11px] text-slate-500 font-medium">
                        Menampilkan {filteredModalItems.length} foto item
                      </span>
                    </div>

                    {filteredModalItems.length === 0 ? (
                      <div className="py-12 text-center text-slate-400">
                        <IconInbox size={36} className="mx-auto mb-2 opacity-50" />
                        <p className="text-xs">Tidak ada item yang sesuai dengan pencarian</p>
                      </div>
                    ) : (
                      <PhotoProvider>
                        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
                          {filteredModalItems.map((item) => {
                            const imgUrl = resolveItemImageUrl(item);
                            return (
                              <div
                                key={item.id || item.kode_item}
                                className="bg-white dark:bg-slate-800 rounded-xl overflow-hidden border border-slate-200 dark:border-slate-700 hover:shadow-md transition-shadow group flex flex-col"
                              >
                                <div className="aspect-square bg-slate-100 dark:bg-slate-700/50 relative flex items-center justify-center overflow-hidden">
                                  {imgUrl ? (
                                    <PhotoView src={imgUrl}>
                                      <img
                                        src={imgUrl}
                                        alt={item.kode_item}
                                        className="w-full h-full object-cover cursor-pointer hover:scale-105 transition-transform duration-200"
                                        onError={(e) => {
                                          e.target.onerror = null;
                                          e.target.src = '';
                                        }}
                                      />
                                    </PhotoView>
                                  ) : (
                                    <div className="flex flex-col items-center justify-center text-slate-400 p-4 text-center">
                                      <IconPhoto size={28} className="opacity-40 mb-1" />
                                      <span className="text-[10px]">Tidak ada foto</span>
                                    </div>
                                  )}
                                  <span className="absolute top-1.5 right-1.5 px-1.5 py-0.5 rounded bg-black/60 backdrop-blur-xs text-white text-[10px] font-mono font-bold">
                                    {item.karat}K
                                  </span>
                                </div>

                                <div className="p-2.5 flex-1 flex flex-col justify-between text-xs">
                                  <div>
                                    <span className="font-mono font-bold text-amber-600 dark:text-amber-400 block truncate">
                                      {item.kode_item}
                                    </span>
                                    <span className="text-slate-600 dark:text-slate-300 font-medium block truncate text-[11px]">
                                      {item.jenis_kategori?.nama_jenis || '-'}
                                    </span>
                                  </div>
                                  <div className="flex items-center justify-between mt-2 pt-1.5 border-t border-slate-100 dark:border-slate-700 text-[11px]">
                                    <span className="text-slate-400">Baki: {item.nomor_rak || '-'}</span>
                                    <span className="font-bold text-slate-800 dark:text-slate-200">
                                      {parseFloat(item.berat || 0).toFixed(3)} gr
                                    </span>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </PhotoProvider>
                    )}
                  </div>
                )}
              </div>

              {/* Modal Footer */}
              <div className="flex flex-col sm:flex-row items-center justify-between gap-3 pt-3 border-t border-slate-100 dark:border-slate-700 flex-shrink-0">
                <div className="text-[11px] text-slate-500 max-w-md truncate">
                  {selectedPengajuan.alasan && (
                    <span>
                      <strong className="text-slate-600 dark:text-slate-400">Alasan:</strong> {selectedPengajuan.alasan}
                    </span>
                  )}
                </div>
                <div className="flex items-center gap-2 self-end sm:self-auto">
                  <button
                    type="button"
                    onClick={() => setIsOpenDetailModal(false)}
                    className="px-4 py-2 text-xs font-semibold text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-xl transition-all cursor-pointer"
                  >
                    Tutup
                  </button>

                  {isVerifikasi && isPending && canVerify && (
                    <>
                      <button
                        type="button"
                        onClick={() => confirmAction(selectedPengajuan.id, 'reject')}
                        className="px-4 py-2 text-xs font-bold text-white bg-rose-600 hover:bg-rose-700 rounded-xl shadow-lg shadow-rose-600/20 transition-all flex items-center gap-1.5 cursor-pointer"
                      >
                        <IconX size={15} /> Tolak Pengajuan
                      </button>
                      <button
                        type="button"
                        onClick={() => confirmAction(selectedPengajuan.id, 'approve')}
                        className="px-4 py-2 text-xs font-bold text-white bg-emerald-600 hover:bg-emerald-700 rounded-xl shadow-lg shadow-emerald-600/20 transition-all flex items-center gap-1.5 cursor-pointer"
                      >
                        <IconCheck size={15} /> Setujui & Hapus dari Etalase
                      </button>
                    </>
                  )}

                  {!isVerifikasi && isPending && !canVerify && (
                    <button
                      type="button"
                      onClick={() => confirmAction(selectedPengajuan.id, 'cancel')}
                      className="px-4 py-2 text-xs font-bold text-white bg-slate-600 hover:bg-slate-700 rounded-xl transition-all flex items-center gap-1.5 cursor-pointer"
                    >
                      <IconX size={15} /> Batalkan Pengajuan
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      })()}

      {/* Modal Konfirmasi Persetujuan / Penolakan */}
      {confirmModal.isOpen && (
        <div className="fixed inset-0 z-[1000] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4">
          <div className="bg-white dark:bg-slate-800 w-full max-w-lg rounded-2xl p-6 shadow-2xl space-y-4 border border-slate-200 dark:border-slate-700">
            <div className="flex items-center justify-between border-b border-slate-100 dark:border-slate-700 pb-3">
              <h3 className="font-bold text-sm text-slate-800 dark:text-slate-100 flex items-center gap-2">
                {confirmModal.action === 'approve' ? (
                  <IconCheck className="text-emerald-500" size={18} />
                ) : confirmModal.action === 'reject' ? (
                  <IconX className="text-rose-500" size={18} />
                ) : (
                  <IconAlertTriangle className="text-amber-500" size={18} />
                )}
                <span>
                  {confirmModal.action === 'approve'
                    ? 'Konfirmasi Persetujuan Permohonan'
                    : confirmModal.action === 'reject'
                    ? 'Konfirmasi Penolakan Permohonan'
                    : 'Konfirmasi Pembatalan Permohonan'}
                </span>
              </h3>
              <button
                type="button"
                onClick={() => setConfirmModal({ isOpen: false, id: null, action: null, pengajuan: null })}
                className="text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 p-1 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700/60 transition-colors cursor-pointer"
              >
                <IconX size={18} />
              </button>
            </div>

            {confirmModal.pengajuan && (
              <div className="bg-slate-50 dark:bg-slate-700/40 p-3.5 rounded-xl border border-slate-200 dark:border-slate-700 text-xs space-y-1.5 text-slate-700 dark:text-slate-300">
                <p>
                  <strong className="text-slate-900 dark:text-slate-100">No. Request:</strong>{' '}
                  <span className="font-mono font-bold text-amber-600 dark:text-amber-400">
                    {confirmModal.pengajuan.batch_id}
                  </span>
                </p>
                <p>
                  <strong className="text-slate-900 dark:text-slate-100">Asal Toko:</strong>{' '}
                  <span className="text-slate-700 dark:text-slate-200">
                    {confirmModal.pengajuan.cabang?.nama_cabang || '-'}
                  </span>
                </p>
                <p>
                  <strong className="text-slate-900 dark:text-slate-100">Pemohon:</strong>{' '}
                  <span className="text-slate-700 dark:text-slate-200">
                    {confirmModal.pengajuan.diajukan_oleh?.name ||
                      confirmModal.pengajuan.user_pemohon?.name ||
                      'Sistem'}
                  </span>
                </p>
                <p>
                  <strong className="text-slate-900 dark:text-slate-100">Total Barang:</strong>{' '}
                  <span className="text-slate-700 dark:text-slate-200">
                    {confirmModal.pengajuan.items?.length || 0} Pcs (
                    {parseFloat(
                      confirmModal.pengajuan.items?.reduce(
                        (total, child) => total + parseFloat((child.item || child)?.berat || 0),
                        0
                      ) || 0
                    ).toFixed(3)}{' '}
                    gr)
                  </span>
                </p>
              </div>
            )}

            <form onSubmit={processConfirmAction} className="space-y-4">
              <div>
                <label className="block text-xs font-bold text-slate-600 dark:text-slate-300 mb-1.5">
                  Catatan Verifikasi{' '}
                  {confirmModal.action === 'reject' && (
                    <span className="text-rose-500">* (Wajib diisi jika menolak)</span>
                  )}
                </label>
                <textarea
                  rows={3}
                  placeholder={
                    confirmModal.action === 'approve'
                      ? 'Catatan opsional...'
                      : confirmModal.action === 'reject'
                      ? 'Jelaskan alasan penolakan...'
                      : 'Alasan pembatalan (opsional)...'
                  }
                  value={catatanVerifikasi}
                  onChange={(e) => setCatatanVerifikasi(e.target.value)}
                  required={confirmModal.action === 'reject'}
                  className="w-full p-2.5 text-xs border border-slate-300 dark:border-slate-600 rounded-xl bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-500 outline-none focus:ring-2 focus:ring-amber-500"
                />
              </div>

              <div className="flex justify-end gap-2 pt-2 border-t border-slate-100 dark:border-slate-700">
                <button
                  type="button"
                  onClick={() => setConfirmModal({ isOpen: false, id: null, action: null, pengajuan: null })}
                  className="px-4 py-2 text-xs font-semibold text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-xl transition-all border border-slate-200 dark:border-slate-700 cursor-pointer"
                  disabled={loading}
                >
                  Batal
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className={`px-5 py-2 text-xs font-bold text-white rounded-xl shadow-lg transition-all flex items-center gap-1.5 cursor-pointer ${
                    confirmModal.action === 'approve'
                      ? 'bg-emerald-600 hover:bg-emerald-700 shadow-emerald-600/20'
                      : confirmModal.action === 'reject'
                      ? 'bg-rose-600 hover:bg-rose-700 shadow-rose-600/20'
                      : 'bg-slate-600 hover:bg-slate-700'
                  }`}
                >
                  {loading ? (
                    <span className="loading loading-spinner loading-xs"></span>
                  ) : confirmModal.action === 'approve' ? (
                    'Setujui & Hapus dari Etalase'
                  ) : confirmModal.action === 'reject' ? (
                    'Tolak Pengajuan'
                  ) : (
                    'Batalkan Pengajuan'
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

    </Layouts>
  );
}
